<template>
  <div>
    <el-dialog
      title="信息披露"
      append-to-body
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
      @before-close="close"
    >
      <div class="center-box" 
        style="height: 60vh;overflow-y: auto;overflow-x: hidden; padding: 0 30px;">
        <div>
          <div class="title-text" style="text-align: center;">八戒小贷信息披露</div>
          <div class="title-text">尊敬的客户：</div>
          <div class="title-text"> &ensp;&ensp;&ensp;&ensp;感谢您关注和选择重庆市猪八戒宜创小额贷款有限公司（下称“八戒小贷”）的信贷服务！为了维护您的权益，请您详细阅读本信息披露。</div>
          <div class="title-text">一、八戒小贷公司的基本信息</div>
          <div class="title-content">&ensp;&ensp;&ensp;&ensp;重庆市猪八戒宜创小额贷款有限公司成立于2016-05-31，股东是重庆猪八戒金融服务有限公司（持股100%），经营场所位于：重庆市渝北区金开大道西段106号2幢8层3号，暂无分支机构。</div>
          <div class="title-content" style="margin: 15px 0;">1.1 营业执照</div>
          <div class="center-box">
            <img src="./img/789456412.png" alt="">
          </div>
          <div class="title-content" style="margin: 15px 0;">1.2 开业批复</div>
          <div class="center-box">
            <img src="./img/189798458.png" alt="">
          </div>
          <div class="center-box">
            <img src="./img/287894455.png" alt="">
          </div>

          <div class="title-content" style="margin: 15px 0;">1.3 董监高信息</div>
          <div>
            <el-table :data="tableData1" style="color: #333;" border>
              <el-table-column prop="index" label="序号" align="center" width="60"/>
              <el-table-column prop="name" label="姓名" width="120"/>
              <el-table-column prop="service" label="职务"/>
            </el-table>
          </div>

          <div class="title-content" style="margin: 15px 0;">1.4 变更信息</div>
          <div>
            <el-table :data="tableData2" border style="color: #333;">
              <el-table-column prop="index" label="序号" align="center" width="60"/>
              <el-table-column prop="data1" label="变更日期" width="100"/>
              <el-table-column prop="data2" label="变更项目"/>
              <el-table-column prop="data3" label="变更前" width="135"/>
              <el-table-column prop="data4" label="变更后" width="135"/>
            </el-table>
          </div>

          <div class="title-text" style="margin-top: 30px;">二、八戒小贷业务介绍</div>
          <div class="title-content">2.1 互联网渠道</div>
          <div class="title-content">官网：<a href="https://www.jr-zbj.com" target="_blank">www.jr-zbj.com</a>，ICP备案号：渝ICP备2025066797号-1；</div>
          <div class="title-content">微信小程序：戒易花，ICP备案号：渝ICP备18007804号-9X。</div>

          <div class="title-content" style="margin: 15px 0;">2.2 产品信息</div>
          <div>
            <el-table :data="tableData3" border style="color: #333;">
              <el-table-column prop="data1" label="产品名称" width="135"/>
              <el-table-column prop="data2" label="戒易花" >
                <template slot-scope="scope">
                  <div class="table_text">{{ scope.row.data2 }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="title-text" style="margin-top: 30px;">三、咨询、投诉渠道</div>
          <div class="title-content">3.1 八戒小贷咨询、投诉渠道</div>
          <div class="title-content">官方网站：<a href="https://www.jr-zbj.com" target="_blank">www.jr-zbj.com</a>（工作日：09：00-18：00）；</div>
          <div class="title-content">邮箱：<a href="mailto:bjxd@bajiegroup.com">bjxd@bajiegroup.com</a>（工作日：09：00-18：00）；</div>
          <div class="title-content">电话：023-88392602（工作日：09：00-18：00）。</div>
          <div class="title-content">3.2 区级监管机构投诉渠道</div>
          <div class="title-content">区级监管部门：重庆市两江新区现代服务业局；</div>
          <div class="title-content">电话023-65869288(工作日：9:00-12:30,14:00-18:00)；</div>
          <div class="title-content">联络地址：重庆两江新区金渝大道66号金山大厦。</div>
          <div class="title-content">如果您对我们的产品或是服务有任何意见、建议，欢迎随时与我们联系！</div>
        </div>
      
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'qrcode',
  data() {
    return {
      dialogVisible: false,
      tableData1:[
        {index:1, name:'张欣辰',service:'执行董事/法定代表人'},
        {index:2, name:'朱小宗',service:'总经理'},
        {index:3, name:'同亚辉',service:'副总经理'},
        {index:4, name:'吕娟',service:'财务负责人'},
        {index:5, name:'项锦秀',service:'监事'},
      ],
      tableData2:[
        {index:1, data1:'2022-01-14',data2:'高级管理人员备案（董事、监事、经理等）',data3:'主要人员信息变更',data4:'主要人员信息变更'},
        {index:2, data1:'2022-01-14',data2:'负责人变更（法定代表人、负责人、首席代表、合伙事务执行人等变更）',data3:'阳军',data4:'张欣辰*'},
        {index:3, data1:'2021-04-29',data2:'章程备案',data3:'章程备案',data4:'章程备案'},
        {index:4, data1:'2021-04-29',data2:'投资人变更（包括出资额、出资方式、出资日期、投资人名称等）',data3:'重庆世乐投资有限公司',data4:'重庆猪八戒金融服务有限公司【名称变更】'},
        {index:5, data1:'2021-04-29',data2:'高级管理人员备案（董事、监事、经理等）',data3:'主要人员信息变更',data4:'主要人员信息变更'},
        {index:6, data1:'2021-04-29',data2:'地址变更（住所地址、经营场所、驻在地址等变更）',data3:'重庆市北部新区青枫北路30号(拓展区A5栋凤凰C座第5层)',data4:'重庆市渝北区金开大道西段106号2幢8层3号'},
        {index:7, data1:'2017-07-06',data2:'投资人变更（包括出资额、出资方式、出资日期、投资人名称等）',data3:'重庆猪八戒网络有限公司【退出】',data4:'重庆世乐投资有限公司【新进】'},
        {index:8, data1:'2017-07-06',data2:'高级管理人员备案（董事、监事、经理等）',data3:'主要人员信息变更',data4:'主要人员信息变更'},
      ],
      tableData3:[
        {data1:'贷款对象', data2:'1.持有效第二代身份证的中国公民(港澳台除外);\n2.具有完全民事行为能力;\n3.年龄:18周岁(含)-60周岁(含);\n4.具有稳定收入来源的非在校学生;\n5.征信记录符合特定要求;\n6.未被列入全国失信人员被执行黑名单;\n7.不涉及刑事案件、重大民事纠纷案件。\n(注:在合规的前提下,上述条件可能不时调整、补充)'},
        {data1:'额度', data2:'3000-200000元'},
        {data1:'利率', data2:'贷款年化利率：\n6%-24%（包括利息、罚息、违约金在内的综合实际年化利率不超过24%）'},
        {data1:'还款方式', data2:'等额本息'},
        {data1:'贷款用途', data2:'消费'},
        {data1:'是否录入征信', data2:'是'},
      ],
    }
  },
  mounted() {

  },
  methods: {

    show(){
      this.dialogVisible = true
    },
    close(){
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="less">
@import "..\..\global\css\mixin\mixin.less";
  .title-text{
    font-weight: bold;
    letter-spacing: 0.02em;
    color: #000;
    line-height: 1.8;
  }
  .title-content{
    letter-spacing: 0.02em;
    line-height: 1.8;
    color: #333;
    a:link{
      color: blue;
    }
    a:hover{
      text-decoration: underline;
    }
  }
  .center-box{
      display: flex; 
      flex-direction: row; 
      justify-content: center;
  }
  .table_text{
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// discloseDialog.vue?4de8180e